import { render, staticRenderFns } from "./Journals.vue?vue&type=template&id=7b1adb6b&scoped=true&"
import script from "./Journals.vue?vue&type=script&lang=js&"
export * from "./Journals.vue?vue&type=script&lang=js&"
import style0 from "./Journals.vue?vue&type=style&index=0&id=7b1adb6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1adb6b",
  null
  
)

export default component.exports